module.exports = __webpack_public_path__ + "img/truck-filled.a54eca3a.svg";